import Table from "../script/table";

//
// Generic HTML table with bootswatch markup.
//
// Input is an array of objects with the same set of properties (fields).
//
// Can be used as 
//      <TableWidget data={result} ... /> 
// where result is an array returned by a MongoDB query.
//
// NOTE: See Utilities.convertDbResultToTableData() for schema.
//

function doFormat(item) {
    if (typeof (item) === 'boolean') {
        return item ? "true" : "false";
    }

    if (typeof (item) === 'number') {
        if (item.toString().indexOf('.') >= 0) {
            return item.toFixed(3);
        }
    }

    if (typeof (item) !== 'string') {
        return item;
    }

    let text = item.trim();
    let repeat;
    do {
        repeat = false;

        if (text.length > 6 && text[0] === '<') {
            if (text.startsWith("<i>") && text.endsWith("</i>")) {
                text = text.substring(3, text.length - 4);
                repeat = true;
            }
            else if (text.startsWith("<b>") && text.endsWith("</b>")) {
                text = text.substring(3, text.length - 4);
                repeat = true;
            }
        }
    } while (repeat);

    return text;
}

//
// props:
//   name              - name of data for logging
//   data              - array of objects (records) with same schema (keys)
//   columns           - optional array filter of properties to display and their order
//   titles            - optional array of column names; must be same length as columns
//   buttons           - optional array of objects, one for each button
//                       { 
//                           label: "Text on button", 
//                           style: "function(button, record)"     // optional
//                           callback: "function(button, record)",
//                       }
//   rowClassFunction  - optional function(record) returning string class (style) data for a row
//   rowSelectCallback - optional function(record) for row click event
//
const TableWidget = (props) => {
    const data = (!props.data || !Array.isArray(props.data) || props.data.length === 0)
        ? []
        : props.data;

    let builder = new Table(data);
    let table = builder.build(props.columns, props.titles);

    let indices = [];
    let id = 0;

    //
    // don't diplay columns :
    //    with '_id' at the end of the data name
    //    with title (header[i]) empty.
    //
    for (let i in table.columns) {
        if (!table.header[i] || table.header[i].length === 0) {
            indices.push(-1);
        } else if (table.columns[i].endsWith("_id") || table.columns[i].startsWith("_")) {
            indices.push(-1);
        } else {
            indices.push(i);
        }
    }

    function defaultRowClass(record) {
        return "table-info";
    }
    let rowClass = props.rowClassFunction ? props.rowClassFunction : defaultRowClass;

    function buttonStyle(button, record) {
        let style;

        if (button.style) {
            style = button.style(button, record);
        } else {
            style = {};
        }

        return style;
    }

    // lookup and return the original record used to build the Table
    function toRecord(row) {
        let item = table.records[row.__record_index];

        return item;
    }

    function cellStyle(text) {
        let style = {};
        if (props.cellNoWrap) {
            style.whiteSpace = "nowrap";
        }

        if (typeof (item) !== 'string') {
            return style;
        }

        text = text.trim();
        let repeat;
        do {
            repeat = false;

            if (text.length > 6 && text[0] === '<') {
                if (text.startsWith("<i>") && text.endsWith("</i>")) {
                    style["font-style"] = "italic";
                    text = text.substring(3, text.length - 4);
                    repeat = true;
                }
                else if (text.startsWith("<b>") && text.endsWith("</b>")) {
                    style["font-weight"] = "bold";
                    text = text.substring(3, text.length - 4);
                    repeat = true;
                }
            }
        } while (repeat);

        return style;
    }

    function headerStyle() {
        let style = {};
        if (props.headerNoWrap) {
            style.whiteSpace = "nowrap";
        }

        return style;
    }

    function onSelect(record) {
        if (props.rowSelectCallback) {
            props.rowSelectCallback(record);
        }
    }

    return (
        <table className="table table-hover">
            <thead>
                <tr>
                    {
                        indices.map((index) => (
                            (index !== -1) && <th scope="col" style={headerStyle()}>{table.header[index]}</th>
                        ))
                    }
                    {
                        props.buttons &&
                        props.buttons.map((button) => (
                            <th scope="col">{button.label}</th>
                        ))
                    }
                </tr>
            </thead>
            <tbody>
                {
                    table.rows.map((row) => (
                        <tr key={(id++).toString()} className={rowClass(toRecord(row))} onClick={() => { onSelect(toRecord(row)) }}>
                            {
                                indices.map((index) => (
                                    (index !== -1) && <td style={cellStyle(row[index])}>{doFormat(row[index])}</td>
                                ))
                            }
                            {
                                props.buttons &&
                                props.buttons.map((button) =>
                                    <th scope="col"><button type="button" className="btn btn-dark btn-sm" style={buttonStyle(button, toRecord(row))} onClick={() => {
                                        button.callback(toRecord(row));
                                    }}>{button.label}</button></th>
                                )
                            }
                        </tr>
                    ))
                }
            </tbody>
        </table>
    );
}

export default TableWidget;